import React from 'react';
import RegisterForm from '../components/Auth/RegisterForm';

export default function RegisterPage() {
  return (
    <div>
      <RegisterForm />
    </div>
  );
}